import { Route } from '@angular/router';
import { redirectAssetGuard } from '@mzic/mzic-guard';
import { languageGuard } from './guards/language.guard';
import { AssetComponent } from './pages/asset/asset.component';
import { ContactComponent } from './pages/contact/contact.component';
import { DesktopUnavailableComponent } from './pages/desktop-unavailable/desktop-unavailable.component';
import { InvestorLandingComponent } from './pages/investor-landing/investor-landing.component';
import { MarketComponent } from './pages/market/market.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

export const mzicIoRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    component: InvestorLandingComponent,
    canActivate: [languageGuard],
  },
  {
    path: ':lang/home',
    component: InvestorLandingComponent,
    title: 'MZIC - Invest in Music',
  },
  {
    path: ':lang/market',
    component: MarketComponent,
    title: 'MZIC - Market',
  },
  {
    path: ':lang/contact',
    component: ContactComponent,
    title: 'MZIC - Contact',
  },
  {
    path: ':lang/assets/:id',
    component: AssetComponent,
    title: 'MZIC',
  },
  {
    path: 'desktop-download',
    component: DesktopUnavailableComponent,
    title: 'MZIC - App Not Available on Desktop',
  },
  {
    path: ':lang/desktop-download',
    component: DesktopUnavailableComponent,
    title: 'MZIC - App Not Available on Desktop',
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
    title: 'MZIC - Page Not Found',
  },
  {
    path: ':lang/not-found',
    component: NotFoundComponent,
    title: 'MZIC - Page Not Found',
  },
  {
    path: '**',
    canActivate: [redirectAssetGuard],
    component: NotFoundComponent,
  },
];
